// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// Seller imports
import SellerLogin from "./pages/SellerLogin";
import SellerResetPassword from "./pages/SellerResetPassword";
import SellerForgotPassword from "./pages/SellerForgotPassword";
import Dashboard from "./pages/Dashboard";
import UploadLicense from "./pages/UploadLicense";
import ApplyWizard from "./pages/Apply";       // index.jsx default export
import OnboardWizard from "./pages/Onboard";   // index.jsx default export

// Driver imports
import Driver from "./pages/Driver";
import DriverDashboard from "./pages/DriverDashboard";
import DriverLogin from "./pages/DriverLogin";
import DriverForgotPassword from "./pages/DriverForgotPassword";
import DriverResetPassword from "./pages/DriverResetPassword";

// Shared imports
import Register from "./pages/Register";       // kept for compatibility, redirects
import Login from "./pages/Login";             // global (if still needed)
import ForgotPassword from "./pages/ForgotPassword"; // global (if still needed)
import ResetPassword from "./pages/ResetPassword";   // global (if still needed)
import Homepage from "./pages/Homepage";

function App() {
  return (
    <Router>
      <Routes>
        {/* Redirect any old /register link to the new onboarding */}
        <Route path="/register" element={<Navigate to="/seller/start" replace />} />

        {/* Global auth (if needed, can remove later once fully namespaced) */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* ---------------- Seller Flows ---------------- */}
        <Route path="/seller/login" element={<SellerLogin />} />
        <Route path="/seller/forgot-password" element={<SellerForgotPassword />} />
        <Route path="/seller/reset-password" element={<SellerResetPassword />} />
        <Route path="/seller/dashboard" element={<Dashboard />} />
        <Route path="/seller/upload-licence" element={<UploadLicense />} />
        <Route path="/seller/start" element={<OnboardWizard />} />   {/* onboarding wizard */}
        <Route path="/seller/apply" element={<ApplyWizard />} />     {/* application wizard */}

        {/* ---------------- Driver Flows ---------------- */}
        <Route path="/driver" element={<Driver />} />
        <Route path="/driver/dashboard" element={<DriverDashboard />} />
        <Route path="/driver/login" element={<DriverLogin />} />
        <Route path="/driver/forgot-password" element={<DriverForgotPassword />} />
        <Route path="/driver/reset-password" element={<DriverResetPassword />} />

        {/* Homepage */}
        <Route path="/" element={<Homepage />} />

        {/* Catch-all fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;

